import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import reduxLink from '../../functions/reduxLink'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-jalaali'
import { lazyLoadHandler } from '../../functions/lazyLoad'
import EmptyTableContent from '../error/EmptyTableContent'
import TableSkeleton from '../skeleton/tableSkeleton'

function CarsTable({
  cars,
  lazy_load_data,
  setLazyLoadData,
  setCars,
  is_all_items_load,
  setAllLoad,
  propsSearchValue,
  selectedPeriod,
}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const showMore = (id) => {
    const link = 'cars'
    reduxLink(link, dispatch)
    navigate(`/${link}/${id}`)
  }

  const getTableDataLazyLoad = async (obj_data) => {
    await lazyLoadHandler(
      `admin/cars`,
      'cars',
      cars,
      10,
      lazy_load_data,
      setLazyLoadData,
      obj_data,
      is_all_items_load,
      setAllLoad,
      setCars,
      propsSearchValue,
      selectedPeriod
    )
  }

  return (
    <div
      className="relative rounded-2xl border border-light-gray dark:border-gray-700 max-h-[450px] overflow-auto scroll-smooth"
      onScroll={getTableDataLazyLoad}
    >
      {cars?.length > 0 ? (
        <table className="w-full text-sm text-right relative whitespace-nowrap">
          <thead className="text-md bg-light-blue dark:bg-slate-800 sticky top-0 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                کد خودرو
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نوع ماشین
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نام و نام خانوادگی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                دسته بندی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                تاریخ مراجعه
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                عملیات
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {cars?.map((car, index) => {
              return !car ? (
                <TableSkeleton key={index} index={index} count={6} />
              ) : (
                <tr key={car.id} className="border-b border-b-light-gray dark:border-b-gray-700">
                  <td className="px-6 py-4 dark:text-amber-50">{car?.code}</td>
                  <td className="px-6 py-4 dark:text-amber-50">{car?.car_model?.model}</td>
                  <td className="px-6 py-4 dark:text-amber-50">{car?.customer?.full_name}</td>
                  <td className={`px-6 py-4 dark:text-amber-50`}>
                    <span style={{ color: `${car?.customer?.customer_type?.color}` }}>
                      {car?.customer?.customer_type?.value}
                    </span>
                  </td>
                  <td className="px-6 py-4 dark:text-amber-50">
                    {car?.last_visit
                      ? `${moment(car?.last_visit).format('jYYYY.jMM.jDD')}`
                      : '- - -'}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => showMore(car.code)}
                      className="font-medium text-link dark:text-link hover:underline"
                    >
                      مشاهده
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'خودرویی ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(CarsTable)
